import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient, HttpParams} from '@angular/common/http';
import {ArtifactId, ProjectId, TestRunId, UserId} from '@webmate-web-core/shared/types/ids';
import {TestEmailAccount} from '@webmate-web-core/shared/types/testmgmt';

@Injectable({
    providedIn: 'root'
})
export class TestmailApi {

    constructor(private http: HttpClient) {
    }

    createTestMail(projectId: ProjectId, testRunId: TestRunId): Observable<TestEmailAccount> {
        const createAddressData = {
            testRunId: testRunId
        };

        return this.http.post<TestEmailAccount>(`/projects/${projectId}/testmail`, createAddressData);
    }

    getTestMailAccounts(projectId: ProjectId, testRunId?: TestRunId, user?: UserId): Observable<TestEmailAccount[]> {
        let params = new HttpParams();
        if (testRunId) {
            params = params.set('testRun', testRunId);
        }
        if (user) {
            params = params.set('user', user);
        }
        return this.http.get<TestEmailAccount[]>(`/projects/${projectId}/testmail`, {params: params});
    }
}
